<script>
  import { getContext } from "svelte"

  const { xScale, yScale, width, height } = getContext("LayerCake")

  export let mapWidth
  export let mapHeight
  export let mapBackgroundImageUrl

  $: screenHeight = $yScale(mapHeight) - $yScale(0)
  $: screenWidth = $xScale(mapWidth) - $xScale(0)
</script>

{#if mapBackgroundImageUrl}
  <div
    class="bg-gray-200"
    style:background-image="url({mapBackgroundImageUrl})"
    style:background-position="{$xScale(0)}px {$yScale(0)}px"
    style:background-repeat="no-repeat"
    style:background-size="{screenWidth}px {screenHeight}px"
    style:height="{$height}px"
    style:width="{$width}px"
  />
{/if}
